// NB. Element.scrollTo doesn't work in MS Edge, but scrollLeft/scrollTop do.
// Window.scrollTo still works and can be used as is.
// https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/15534521/
const isElementScrollToSupported = 'scrollTo' in Element.prototype;

// NB. If the check passes, it also means that ScrollToOptions are supported
// https://stackoverflow.com/a/51070207
const isSmoothScrollSupported = 'scrollBehavior' in document.documentElement.style;

// Cross-browser Element.closest()
// http://developer.mozilla.org/en-US/docs/Web/API/Element/closest
export const closest = (element, selector) => {
  let closestElement = element;

  do {
    if (closestElement.matches(selector)) {
      return closestElement;
    }

    closestElement = closestElement.parentElement || closestElement.parentNode;
  } while (closestElement !== null && closestElement.nodeType === 1);

  return null;
};

export const createGhostElement = (tagName = 'div') => {
  const element = document.createElement(tagName);
  element.style.visibility = 'hidden';
  element.style.position = 'absolute';
  element.style.top = '-9999px';

  return element;
};

export const findScrollParent = element => {
  const overflowRegex = /auto|scroll/;

  if (!element) {
    return null;
  }

  element = element.parentElement;

  while (element && element.nodeType === 1) {
    const computedStyle = window.getComputedStyle(element);

    if (overflowRegex.test(computedStyle.overflow)) {
      return element;
    }

    element = element.parentElement || element.parentNode;
  }

  return null;
};

export const getScrollBottom = element => {
  if (element === window) {
    return document.documentElement.scrollHeight - window.pageYOffset - Math.round(window.innerHeight);
  }

  return element.scrollHeight - element.scrollTop - Math.round(element.clientHeight);
};

export const rem = value => {
  const rootStyle = window.getComputedStyle(document.body);
  const baseFontSize = parseFloat(rootStyle.getPropertyValue('font-size'));
  return value * baseFontSize;
};

/**
 * Based on:
 * https://davidwalsh.name/detect-scrollbar-width
 */
export const scrollbarWidth = (() => {
  const ghost = createGhostElement();
  ghost.style.height = '100px';
  ghost.style.overflow = 'scroll';
  ghost.style.width = '100px';
  document.body.appendChild(ghost);

  const value = ghost.offsetWidth - ghost.clientWidth;
  document.body.removeChild(ghost);

  return value;
})();

export const scrollTo = (element, options) => {
  if (isElementScrollToSupported && isSmoothScrollSupported) {
    element.scrollTo(options);
  } else {
    element.scrollLeft = options.left;
    element.scrollTop = options.top;
  }
};

export const scrollToBottom = (element, behavior = 'auto') => {
  scrollTo(element, {
    behavior,
    left: element.scrollLeft,
    top: element.scrollHeight
  });
};

export const scrollToTop = (element, behavior = 'auto') => {
  scrollTo(element, {
    behavior,
    left: element.scrollLeft,
    top: 0
  });
};

/**
 * This helper method is here because Internet Explorer does not
 * support the second argument to Element.classList.toggle.
 */
export const toggleClass = (element, className, value) => {
  if (value) {
    element.classList.add(className);
  } else {
    element.classList.remove(className);
  }
};
